import './UnpaidCloses.scss'

import React, { Component } from 'react'
import { connect } from 'react-redux'
import Table from 'common/views/atoms/Table/Table'
import moment from 'moment-timezone'
import ReactTooltip from 'react-tooltip'

import { selectIsTransitionBroker } from 'broker/selectors/auth'

import {
  masqueradeAgent, fetchUnpaidCloses, searchUnpaidCloses, fetchMarkets,
  fetchAgents, download_w9
} from 'broker/redux/account'

import {
  getTimeframeFromFilterList,
  getQueriesFromFilterList,
  exportSearchFiltersForSegment,
  filtersWithValues
} from 'broker/util/helper'

import { labelFor } from 'common/util/helper'
import {
  ACCOUNTING_SUPPORT_EMAIL, BUYER_TYPE, PRICE, LEAD_TYPE, REFERRAL_EXPORT_TIMEFRAME,
  CLOSING_STMT_INCOMPLETE_REASON, DISPLAY_PRICE, UNIVERSAL_EXPORT_TIMEFRAME_ALL_TIME,
  TRANSACTION_DOCUMENT_STATUS
} from 'common/constants'

import { segmentEventTracker } from 'common/analytics'

import { selectAgentTerminationEnabled } from 'common/redux/selectors/auth'

import { AgentTerminated } from 'common/views/components/AgentTerminated'
import LeadTypeBadges from "broker/views/components/LeadTypeBadges";
import { GenericLeadsDownloader } from "broker/util/downloader";
import DownloadModal from "broker/views/components/common/DownloadModal";
import _ from "lodash";
import { FilteredList } from "broker/views/components/common/Filter/FilteredList";
import styled from 'styled-components'
import RDCProLogoSrc from '../../../../images/rdc_pro_logo.svg'

const FILTER_KEYS = ['market', 'client', 'price', 'agent']
const FILTER_TYPE_OPTIONS = [
  { value: 'market', label: 'Market' },
  { value: 'client', label: 'Client Category' },
  { value: 'price', label: 'Price Range' },
  { value: 'agent', label: 'Agent Name' },
  { value: 'timeframe', label: 'Time Period' },
  { value: 'market_vip', label: 'Market VIP' }
]

const MARKET_VIP_FILTER = [{ value: 'true', label: 'Only' }]

const RDCProLogo = styled.img`
  height: 30px;
`

class ClosingItemsOnlinePanel extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { account } = this.props

    return (
      <div className="ClosingItemsOnlinePanel">
        <div className="ClosingItemsOnlinePanel__box">
          <div className="ClosingItemsOnlinePanel__block ClosingItemsOnlinePanel__block--50 ClosingItemsOnlinePanel__block--padding_right ClosingItemsOnlinePanel__block--border_right">
            <RDCProLogo src={RDCProLogoSrc} />
            <h3>Pay your transaction fees and upload your closing documents with our new payment portal</h3>
            <p>Enjoy the convenience of our secure online platform to pay your transactions fees.</p>
            <button onClick={() => window.open(account.realtor_referral_url, '_blank')} className="ClosingItemsOnlinePanel__btn">Pay now</button>
          </div>
          <div className="ClosingItemsOnlinePanel__block ClosingItemsOnlinePanel__block--50 ClosingItemsOnlinePanel__block--padding_left">
            <h4>Items you will need:</h4>
            <ol>
              <li>Your transaction ID for us to identify which transaction your payment is for.</li>
              <li>Your closing documents to provide evidence of your transaction.</li>
              <li>A method of payment like a credit card or bank information to process an eCheck.</li>
            </ol>
            <h4>Help links:</h4>
            <p className="bold">
              <a href="https://support.realtor.com/s/article/What-closing-documents-will-Opcity-accept"
                target="_blank" rel="noopener noreferrer"
                onClick={() => segmentEventTracker('Support-Link Clicked', { 'support_topic': 'closing-documents-leases-rentals' })}>
                What Qualifies as Closing Documentation?
              </a>
            </p>
          </div>
        </div>
      </div>
    )
  }
}

class ClosingItemsInfo extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div>
        <div className="ClosingItemsPanel__box ClosingItemsPanel__box--top-margin">
          <div className="ClosingItemsPanel__block ClosingItemsPanel__block--25">
            <h4>Where to send closing items:</h4>
            <p className="bold light">Common Questions</p>
            <p className="ClosingItemsPanel__indent ClosingItemsPanel__text--small light">
              <a href="https://support.realtor.com/s/article/My-agent-just-closed-a-transaction-How-do-I-make-sure-they-get-credit-for-their-close"
                target="_blank" rel="noopener noreferrer"
                onClick={() => segmentEventTracker('Support-Link Clicked', { 'support_topic': 'closed-a-transaction-heres-what-to-do-next' })}>
                Closed a Transaction? Here’s What to do Next.
              </a>
            </p>
            <p className="ClosingItemsPanel__indent ClosingItemsPanel__text--small light">
              <a href="https://support.realtor.com/s/article/What-closing-documents-will-Opcity-accept"
                target="_blank" rel="noopener noreferrer"
                onClick={() => segmentEventTracker('Support-Link Clicked', { 'support_topic': 'closing-documents-leases-rentals' })}>
                What Qualifies as Closing Documentation?
              </a>
            </p>
          </div>
          <div className="ClosingItemsPanel__block ClosingItemsPanel__block--60">
            <div className="ClosingItemsPanel__box">
              <div className="icon icon-email"></div>
              <div>
                <h4 className="ClosingItemsPanel__sub-heading">By Email:</h4>
                <ReactTooltip />
                <p className="light">
                  Please include your <span className="bold">Transaction ID</span> in the email subject line of all documents
                  sent to Opcity for a specific transaction as well as in the note for any payments associated to a specific
                  transaction. <span className="fa fa-question-circle"
                    data-tip="The Transaction ID be found in the Transaction Details column below or in any
                                               emails you have received in relation to payment for a transaction"/>
                </p>
                <p><a href="mailto:docs@opcity.com">docs@opcity.com</a></p>
                <button className="btn ClosingItemsPanel__button--link ClosingItemsPanel__button--no-padding" onClick={() => {
                  segmentEventTracker('Data Downloaded', { 'downloaded_data': 'opcity_w9_form' })
                  this.props.handleDownloadW9()
                }}>
                  <i className="fa fa-download" /> Download Opcity Form W-9
                </button>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className="ClosingItemsPanel__box ClosingItemsPanel__box--justify-between">
          <div className="ClosingItemsPanel__block ClosingItemsPanel__block--25">
            <h4>Where to send payment:</h4>
            <p className="bold light">Common Questions</p>
            <p className="ClosingItemsPanel__indent ClosingItemsPanel__text--small light">
              <a href="https://support.realtor.com/s/article/I-sent-payment-for-a-transaction-so-why-is-it-still-showing-as-unpaid"
                target="_blank" rel="noopener noreferrer"
                onClick={() => segmentEventTracker('Support-Link Clicked', { 'support_topic': 'i-sent-payment-why-is-the-transaction-still-showing-as-unpaid' })}>
                I Sent Payment. Why Is the Transaction Still Showing as Unpaid?
              </a>
            </p>
            <p className="ClosingItemsPanel__indent ClosingItemsPanel__text--small light">
              <a href="https://support.realtor.com/s/article/what-are-the-Fees"
                target="_blank" rel="noopener noreferrer"
                onClick={() => segmentEventTracker('Support-Link Clicked', { 'support_topic': 'why-do-i-have-an-outstanding-balance-on-my-account' })}>
                Why do I Have an Outstanding Balance on my Account?
              </a>
            </p>
            <p className="ClosingItemsPanel__indent ClosingItemsPanel__text--small light">
              Still have a question?
            </p>
            <p className="ClosingItemsPanel__indent ClosingItemsPanel__text--small light">
              Email: <a href={`mailto:${ACCOUNTING_SUPPORT_EMAIL}`}>{ACCOUNTING_SUPPORT_EMAIL}</a>.
            </p>
          </div>
          <div className="ClosingItemsPanel__block ClosingItemsPanel__block--25">
            <div className="ClosingItemsPanel__box">
              <div className="icon icon-mail" />
              <div>
                <h4 className="ClosingItemsPanel__sub-heading">Checks mailed to:</h4>
                <table>
                  <tbody>
                    <tr>
                      <td>Move Sales/Opcity</td>
                    </tr>
                    <tr>
                      <td>PO Box 844012</td>
                    </tr>
                    <tr>
                      <td>Dallas, TX 75284-4012</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="ClosingItemsPanel__box ClosingItemsPanel__box--top-margin">
              <div className="icon icon-courier" />
              <div>
                <h4 className="ClosingItemsPanel__sub-heading">Overnight (Courier only):</h4>
                <table>
                  <tbody>
                    <tr>
                      <td>Bank of America Lockbox Services</td>
                    </tr>
                    <tr>
                      <td>Lockbox 844012</td>
                    </tr>
                    <tr>
                      <td>1950 N. Stemmons Freeway</td>
                    </tr>
                    <tr>
                      <td>Suite 5010</td>
                    </tr>
                    <tr>
                      <td>Dallas, TX 75207</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="ClosingItemsPanel__block ClosingItemsPanel__block--45">
            <div className="ClosingItemsPanel__box">
              <div className="icon icon-bank-transfer" />
              <div>
                <h4 className="ClosingItemsPanel__sub-heading">By Bank Transfer:</h4>
                <p className="ClosingItemsPanel__text">
                  When paying by ACH or wire, it is required to send an email to RCCBILLING@realtor.com to ensure timely
                  application of your payment.
                </p>
                <p className="ClosingItemsPanel__text">
                  Please include the below information when sending your email:
                </p>
                <ul className="ClosingItemsPanel__text ClosingItemsPanel__bottom_spacing">
                  <li>Amount sent and when it was sent</li>
                  <li>Brokerage name, agent name, and referral name</li>
                  <li>Transaction ID</li>
                </ul>
                <table>
                  <tbody>
                    <tr>
                      <td>Bank Name:</td>
                      <td>Bank of America Merrill Lynch</td>
                    </tr>
                    <tr>
                      <td>Beneficiary Name:</td>
                      <td>Move Sales, Inc, dba Opcity</td>
                    </tr>
                    <tr>
                      <td>Account Number:</td>
                      <td>1257-6-68284</td>
                    </tr>
                    <tr>
                      <td>ACH Routing Number:</td>
                      <td>122000661</td>
                    </tr>
                    <tr>
                      <td>Wire Routing Number:</td>
                      <td>026009593 (Domestic Wires)</td>
                    </tr>
                    <tr>
                      <td>Bank Address:</td>
                      <td>101 South Tryon Street<br />
                        Charlotte, NC 28255</td>
                    </tr>
                    <tr>
                      <td>Beneficiary Address:</td>
                      <td>30700 Russell Ranch Road, Suite 290<br />
                        Westlake Village, CA 91362</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


const ToggleArrow = ({ open, onClick }) => (
  open ? <div className="icon icon-collapse" onClick={onClick}></div> : <div className="icon icon-expand" onClick={onClick}></div>
)

class ClosingItemsPanel extends React.Component {
  constructor(props) {
    super(props)
  }

  state = {
    displayOtherWays: false
  }

  handleDownloadW9 = () => {
    const { dispatch } = this.props

    dispatch(download_w9()).then((response) => {
      window.open(response.pdf_url, '_blank')
    })
  }
  render() {
    const { account } = this.props

    return (
      <div className="ClosingItemsPanel">
        <div className="ClosingItemsPanel__box ClosingItemsPanel__box--justify-between ClosingItemsPanel__box--center_align_items">
          <div className="ClosingItemsPanel__block">
            <h3>Other ways to pay your transaction fees.</h3>
            <p>Pay your transactions fees by check or bank transfer and emailing your closing documents.</p>
          </div>
          <div className="ClosingItemsPanel__block">
            <ToggleArrow className="ClosingItemsPanel__block--toggle-detail" open={this.state.displayOtherWays} onClick={() => {
              this.setState({ displayOtherWays: !this.state.displayOtherWays })
            }} />
          </div>
        </div>
        {this.state.displayOtherWays && <ClosingItemsInfo handleDownloadW9={this.handleDownloadW9} />}
      </div>
    )
  }
}

class UnpaidCloses extends Component {

  constructor(props) {
    super(props)

    this.state = {
      filters: [{ filter_type: 'timeframe', filter_value: UNIVERSAL_EXPORT_TIMEFRAME_ALL_TIME }],
      activeFilters: [{ filter_type: 'timeframe', filter_value: UNIVERSAL_EXPORT_TIMEFRAME_ALL_TIME }],
      unusedFilters: FILTER_KEYS.filter(filter => filter.value !== 'timeframe'),
      dirty: false,
      options: {
        client: BUYER_TYPE,
        price: PRICE,
        timeframe: REFERRAL_EXPORT_TIMEFRAME,
        market_vip: MARKET_VIP_FILTER,
        agent: [{ value: "waiting-for-agents", label: "Waiting for agents..." }],
      },
    }
    this.downloader = new GenericLeadsDownloader()
    this.handleUnpaidClosesExport = this.handleUnpaidClosesExport.bind(this)
    this.search = this.search.bind(this)
    this.handleFilter = this.handleFilter.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
  }

  componentWillMount() {
    if (this.props.isTransitionBroker && !_.includes(FILTER_KEYS, 'market_vip')) {
      FILTER_KEYS.push('market_vip')
    }

    this.props.dispatch(fetchMarkets())
      .then(response => {
        const { options } = this.state
        this.setState({
          options: {
            ...options,
            market: response.markets.map(market => {
              return { value: market.id, label: market.name }
            })
          }
        })

      })

    this.props.dispatch(fetchAgents())
      .then(response => {
        const { options } = this.state
        this.setState({
          options: {
            ...options,
            agent: response.agents.map(agent => {
              return { value: agent.id, label: agent.name }
            })
          },
          extraForSegment: {
            ...this.state.extraForSegment,
            agentUserHash: response.agents.map(agent => {
              return { id: agent.id, userHash: agent.user_hash }
            })
          }
        })
      })
  }

  toggleExcludeOnHold = (e) => {
    this.setState({ excludeOnHold: e.target.checked, dirty: true })
  }

  addFilter = () => {
    this.setState({
      filters: [...this.state.filters].concat({ filter_type: null, filter_value: null })
    })
    this.updateFilterType(this.state.filters.length, this.state.unusedFilters[0])
  }

  removeFilter = (idx) => {
    let filters = [...this.state.filters]

    filters.splice(idx, 1)
    let newActiveFilters = filters.filter(filter => filter.filter_type && filter.filter_value)
    let unusedFilters = FILTER_KEYS.filter(val => filters.every(filter => filter.filter_type !== val))

    this.setState({
      filters,
      unusedFilters,
      activeFilters: newActiveFilters,
      dirty: true
    }, this.handleFilter)
  }

  updateFilterType = (idx, filter_type) => {
    let filters = [...this.state.filters]
    filters[idx] = {
      filter_type,
      filter_value: null
    }
    let unusedFilters = FILTER_KEYS.filter(val => filters.every(filter => filter.filter_type !== val))
    this.setState({
      filters,
      unusedFilters
    })
  }

  updateFilterValue = (idx, filter_value, run_search = false) => {
    const search_callback = run_search ? this.handleFilter : null
    let filters = [...this.state.filters]
    filters[idx]['filter_value'] = filter_value
    let activeFilters = filters.filter(filter => filter.filter_type && filter.filter_value)
    this.setState({
      filters,
      activeFilters,
      dirty: true
    }, search_callback)
  }

  handleFilter = _.debounce(() => { this.search() }, 2000)

  handleSearch = _.debounce((searchTerm) => {
    this.setState({ searchTerm })
    this.search(searchTerm)
  }, 800)

  search = (term) => {
    this.downloader.initializeSearchState()
    const activeFilters = getQueriesFromFilterList(this.state.activeFilters)
    if (term || !!this.state.searchTerm || activeFilters.length > 0) {
      term = term || this.state.searchTerm
      this.props.dispatch(searchUnpaidCloses(getTimeframeFromFilterList(this.state.activeFilters), term, activeFilters, this.state.excludeOnHold, this.props.nav, true))
        .then(() => {
          this.setState({ searching: false })
        }).catch((error) => {
          this.downloader.searchTimedOut()
          throw error
        })
    } else {
      this.props.dispatch(fetchUnpaidCloses(getTimeframeFromFilterList(this.state.activeFilters), this.state.excludeOnHold, this.props.nav, true))
        .then(() => {
          this.setState({ searching: false })
        }).catch((error) => {
          this.downloader.searchTimedOut()
          throw error
        })
    }
    const filteredFilters = filtersWithValues(this.state.filters)
    this.setState({ searching: true, dirty: false, filters: filteredFilters })
  }

  handleUnpaidClosesExport = () => {
    const baseSegmentProperties = {
      'downloaded_data': 'unpaid_closes'
    }

    const { activeFilters, extraForSegment } = this.state
    const agentFilter = activeFilters.find(filterEntry => filterEntry.filter_type === 'agent')
    const agentUserHashArray = extraForSegment ? extraForSegment.agentUserHash : []
    const foundAgent = agentFilter && agentUserHashArray.find(agent => agent.id === agentFilter.filter_value)
    const agentUserHash = agentFilter && foundAgent && foundAgent.userHash

    const searchFiltersForSegmentExport = exportSearchFiltersForSegment(
      FILTER_TYPE_OPTIONS,
      this.state.activeFilters,
      agentUserHash && { 'agent': agentUserHash }
    )

    segmentEventTracker('Data Downloaded', {
      ...baseSegmentProperties,
      ...searchFiltersForSegmentExport
    })

    this.downloader.download({
      exportUrl: '/download/unpaid_closes',
      auth: this.props.auth, email: this.props.email, dispatch: this.props.dispatch, account: this.props.account,
      activeFilters: this.state.activeFilters, searchTerm: this.state.searchTerm,
      excludeOnHold: this.state.excludeOnHold
    })
  }

  handleClickForSegmentEvent = (item, eventName, otherSegmentProperties) => {
    const { activeFilters } = this.state

    const baseSegmentProperties = {
      'transaction_agent_user_hash': item.agent_user_hash,
      'transaction_likelihood_category': item.likelihood_category,
      'transaction_is_cashback': item.is_cashback,
      'transaction_external_id': item.external_transaction_id
    }

    const searchFiltersForSegmentExport = exportSearchFiltersForSegment(
      FILTER_TYPE_OPTIONS,
      activeFilters,
      { 'agent': item.agent_user_hash }
    )

    segmentEventTracker(eventName, {
      ...baseSegmentProperties,
      ...searchFiltersForSegmentExport,
      ...otherSegmentProperties
    })
  }

  render() {
    const { props, handleClickForSegmentEvent, state } = this
    const { dispatch, account } = props
    const { root } = props
    const { isLoading } = root
    const defaultNav = { next_page: null, prev_page: null, page_number: 1 }
    const useNav = { ...defaultNav, ...(_.get(props, 'account.nav', {})) }
    const timeFrameFilter = this.state.filters[0]
    const timeFrameOptions = this.state.options[timeFrameFilter.filter_type]

    function handleViewAgentClick(item) {
      dispatch(masqueradeAgent(item.agent_id))
        .then(response => {
          window.open(
            response.url,
            '_blank'
          )
        })
    }

    function getPage(forward) {
      const { activeFilters, searchTerm, excludeOnHold } = state
      let newNav = {
        'page_number': forward ? useNav.page_number + 1 : useNav.page_number - 1,
        'page_key': forward ? useNav.next_page : useNav.prev_page
      }
      props.dispatch(searchUnpaidCloses(getTimeframeFromFilterList(activeFilters), searchTerm, activeFilters, excludeOnHold, newNav, true))
    }

    function forward() {
      getPage(true)
    }

    function backward() {
      getPage(false)
    }

    function renderTeam(item) {
      return <div className="UnpaidCloses__team">
        {item.loan_officer ?
          <div className={item.loan_officer && item.settlement_officer ? "UnpaidCloses__partners" : "UnpaidCloses__partners--empty"}>
            <div className="UnpaidCloses__block"><strong>{item.loan_officer}</strong></div>
            <div>
              <a href={"mailto:" + item.loan_officer_email}>
                <span className="UnpaidCloses__email fa fa-envelope"></span>
              </a>

              <span>{item.loan_officer_phone}</span>
            </div>
            <div className="UnpaidCloses__ellipsis">Lender: {item.loan_broker}</div>
          </div> : (item.agent_close_lender_other && <div>Lender: {item.agent_close_lender_other}</div>)
        }

        {item.settlement_officer &&
          <div>
            <div className="UnpaidCloses__block"><strong>{item.settlement_officer}</strong></div>
            <div>
              <a href={"mailto:" + item.settlement_officer_email}>
                <span className="UnpaidCloses__email fa fa-envelope"></span>
              </a>
              <span>{item.settlement_officer_phone}</span>
            </div>
            <div className="UnpaidCloses__ellipsis">Closing Services: {item.settlement_broker}</div>
          </div>
        }
      </div>
    }

    function getPaymentPhrase(isMVIP, isPartialPayment, isOverdue, isPaymentReceived, partialPayment, partialPaymentNotOverdue, paymentReceived, paymentOverdue, paymentNotOverdue) {
      if (isMVIP)
        return null

      if (isPartialPayment) {
        if (isOverdue)
          return partialPayment
        else
          return partialPaymentNotOverdue
      }

      if (isPaymentReceived)
        return paymentReceived

      if (isOverdue)
        return paymentOverdue
      else
        return paymentNotOverdue
    }

    function getTransactionDocumentStatus(item) {
      // The old way
      if (!item.transaction_document_status) {
        if (item.docs_received)
          return <div><span className="UnpaidCloses__success"><i className="fa fa-check-circle" /></span> Closing Statement Received</div>
        const overdue = item.close_days_ago > 14
        if (item.closing_stmt_incomplete_reason) {
          const closing_stmt_incomplete_reason = labelFor(CLOSING_STMT_INCOMPLETE_REASON, item.closing_stmt_incomplete_reason)
          if (overdue)
            return <div><i className="fa fa-circle-o" /> Additional Closing Statement Overdue <div className="UnpaidCloses__remaining"><span className="UnpaidCloses__remaining-label">{closing_stmt_incomplete_reason}</span> </div> </div>
          return <div><span><i className="fa fa-circle-o" /> Missing Additional Closing Statement</span> <div className="UnpaidCloses__remaining"><span className="UnpaidCloses__remaining-label">{closing_stmt_incomplete_reason}</span> </div> </div>
        }
        if (overdue)
          return <div><span><i className="fa fa-circle-o" /> Closing Statement Overdue</span></div>
        return <div><span><i className="fa fa-circle-o" /> Missing Closing Statement</span></div>
      }

      // The "overriden" document status
      if (item.transaction_document_status === 'closing-stmt-received')
        return <div><span className="UnpaidCloses__success"><i className="fa fa-check-circle" /></span> Closing Statement Received</div>
      return <div><span><i className="fa fa-exclamation-circle" /> {labelFor(TRANSACTION_DOCUMENT_STATUS, item.transaction_document_status)} </span></div>
    }

    function renderRow(item) {
      const agentTerminationEnabled = selectAgentTerminationEnabled(props)

      const overdue = item.close_days_ago > 14
      const isPartialPayment = (!item.full_payment_received && !!item.overdue_balance_remaining_currency && !!item.overdue_paid_currency)

      const partialPayment = <div><span><i className="fa fa-exclamation-circle" /> Outstanding Balance Overdue</span><div className="UnpaidCloses__remaining"><span className="UnpaidCloses__remaining-label UnpaidCloses__remaining-danger">Remaining Balance: </span><span className="UnpaidCloses__danger">{item.overdue_balance_remaining_currency}</span></div></div>
      const partialPaymentNotOverdue = <div><span><i className="fa fa-exclamation-circle" /> Missing Outstanding Balance</span><div className="UnpaidCloses__remaining"><span className="UnpaidCloses__remaining-label">Remaining Balance: </span><span className="UnpaidCloses__remaining-value">{item.overdue_balance_remaining_currency}</span></div></div>
      const paymentReceived = <div><span className="UnpaidCloses__success"><i className="fa fa-check-circle" /></span> Payment Received</div>
      const paymentOverdue = <div><span><i className="fa fa-circle-o" /> Payment Overdue</span></div>
      const paymentNotOverdue = <div><span><i className="fa fa-circle-o" /> Missing Payment</span></div>

      const paymentStatusForSegment = isPartialPayment ? 'Paid in-Part' : item.payment_received ? 'Paid' : 'Not Paid'

      const documentStatus = getTransactionDocumentStatus(item)

      const documentStatusForSegment = item.docs_received ? 'Documents Received' : (item.closing_stmt_incomplete_reason ? 'Missing: ' + labelFor(CLOSING_STMT_INCOMPLETE_REASON, item.closing_stmt_incomplete_reason) : 'Missing')

      const daysWeeksCloseDateOverdue = item && item.time_since_close ? item.time_since_close.toString().replace('ago', 'overdue') : ''

      return <tr key={item.id} className={overdue ? 'UnpaidCloses__overdue' : null}>
        <td>
          <div>
            <div className="UnpaidCloses__assignment-name">
              <strong>{item.override_name ? item.override_name : item.name}</strong>
            </div>
          </div>
          <div>{item.email}</div>
          <div>{item.phone}</div>
          <div>
            {labelFor(BUYER_TYPE, item.client_category)}: {item.max_budget ? item.standard_max_budget : labelFor(DISPLAY_PRICE, item.price_category)}
          </div>

          {item.broker_is_bla_enabled &&
            <div>Lead Source: {item.lead_source_name}</div>
          }

          <div>{labelFor(LEAD_TYPE, item.likelihood_category)}</div>
          <div>{item.market}  {item.zipcode}</div>

          <div>Assigned: {moment.utc(item.created_at).local().format("MM-DD-YY h:mm A")}</div>
        </td>
        <td>
          <div className="UnpaidCloses__block"><a onClick={() => {
            handleClickForSegmentEvent(item, 'Sub-User Masqueraded', {
              'masqueraded_user_hash': item.agent_user_hash,
              'transaction_payment_status': paymentStatusForSegment,
              'transaction_document_status': documentStatusForSegment,
              'transaction_is_overdue': overdue,
              'transaction_days_since_close': item.close_days_ago
            })
            handleViewAgentClick(item)
          }}>{item.agent}</a></div>
          <div className="UnpaidCloses__block">
            <a className="UnpaidCloses__email" href={"mailto:" + item.agent_email}>
              <span className="UnpaidCloses_email fa fa-envelope" />
            </a>
            <span>{item.agent_phone}</span>
          </div>

          {agentTerminationEnabled && item.agent_terminated_at &&
            <AgentTerminated terminatedAt={item.agent_terminated_at} />
          }

          <div>
            {item.agent_is_delinquent &&
              <span className="UnpaidCloses__danger"><i className="fa fa-times-circle" /> Delinquent</span>
            }
          </div>
        </td>
        <td>
          {renderTeam(item)}
        </td>
        <td>
          {item.agent_close_date &&
            <div>
              <span className="pill pill-danger UnpaidCloses__block">{daysWeeksCloseDateOverdue}</span>
              <div className="UnpaidCloses__projected-close-date">
                <span data-tip="This date has been set by the assigned agent as the closed date within Referral Manager">Projected Close Date:</span>
              </div>
              <div><i className="fa fa-calendar-check-o" /> {item.agent_close_date}</div>
            </div>
          }

          <div className="UnpaidCloses__issues">
            {getPaymentPhrase(item.is_market_vip, isPartialPayment, overdue, item.payment_received, partialPayment, partialPaymentNotOverdue, paymentReceived, paymentOverdue, paymentNotOverdue)}
            {documentStatus}
          </div>
        </td>
        <td>
          <LeadTypeBadges leadTags={item.lead_tags} />

          <div className="UnpaidCloses__block">Transaction ID: {item.external_transaction_id}</div>
          <div><strong>Property Details:</strong></div>
          <div>{item.agent_property_address}</div>
          {item.agent_amount &&
            <div>${item.agent_amount}</div>
          }
          {item.agent_mls &&
            <div>MLS: {item.agent_mls}</div>
          }

          {item.transaction_in_review_at &&
            <div className="UnpaidCloses__block UnpaidCloses__in-review">
              In Review<br />
              {item.transaction_in_review_at}
            </div>
          }

          {item.pdf_url &&
            <div className="UnpaidCloses__agreement" onClick={() => {
              handleClickForSegmentEvent(item, 'Data Downloaded', {
                'downloaded_data': 'referral_agreement',
                'transaction_payment_status': paymentStatusForSegment,
                'transaction_document_status': documentStatusForSegment,
                'transaction_is_overdue': overdue,
                'transaction_days_since_close': item.close_days_ago
              })
            }}>
              <a href={item.pdf_url} target="_new">Referral agreement</a>
            </div>
          }
          <button onClick={() => window.open(account.realtor_referral_url, '_blank')} className="UnpaidCloses__btn">Pay now</button>
        </td>
      </tr>
    }

    function renderSection(items) {
      return (
        <div key={"UnpaidCloses"}>
          <Table>
            <thead>
              <tr>
                <th>Client</th>
                <th>Agent</th>
                <th>Partners</th>
                <th>Status</th>
                <th>Transaction Details</th>
              </tr>
            </thead>
            <tbody>
              {items.map(renderRow)}
            </tbody>
          </Table>
        </div>
      )
    }

    return (
      <div>
        <ReactTooltip />
        <div className="ClosingItemsOnlinePanelContainer">
          <ClosingItemsOnlinePanel {...this.props} />
        </div>
        <div className="ClosingItemsPanelContainer">
          <ClosingItemsPanel {...this.props} />
        </div>

        <div className="UnpaidCloses">
          <FilteredList
            checkboxOptions={{ onHold: { onChange: this.toggleExcludeOnHold } }}
            dirty={this.state.dirty}
            filters={this.state.filters}
            filterOptions={this.state.options}
            isLoading={isLoading}
            maxLengthReached={Object.keys(this.state.options).length == (Object.keys(this.state.filters).length)}
            nav={this.props.account ? this.props.account.nav : null}
            timeFrameFilter={timeFrameFilter}
            timeFrameOptions={timeFrameOptions}
            typeOptionsConsts={FILTER_TYPE_OPTIONS}
            unusedFilters={this.state.unusedFilters}
            onAddFilter={this.addFilter}
            onApply={this.handleFilter}
            onExport={this.handleUnpaidClosesExport}
            onPageForward={forward}
            onPageBackward={backward}
            onRemoveFilter={this.removeFilter}
            onSearch={this.handleSearch}
            onUpdateFilterType={this.updateFilterType}
            onUpdateFilterValue={this.updateFilterValue}
          >
            {props.account.search_results ? props.account.search_results.length !== 0 ? renderSection(props.account.search_results) : null : <div className="UnpaidCloses__loading pulse" />}
          </FilteredList>
        </div>
        <DownloadModal {...this.props} />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  isTransitionBroker: selectIsTransitionBroker(state)
})

export default connect(mapStateToProps)(UnpaidCloses)
